export default "__VITE_ASSET__DFRdWB$z__"